var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageLoading)?_c('div',{staticStyle:{"display":"flex","top":"0px","position":"fixed","left":"0px","right":"0px","bottom":"0px","background-color":"rgba(247, 247, 247, 0.6)","z-index":"9999","justify-content":"center","align-items":"center"}},[_c('div',[_c('div',[(_vm.pageLoading)?_c('h3',[_vm._v(_vm._s(_vm.message))]):_vm._e()])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }